import { useMemo } from 'react';
import { useApp } from '../context/AppContext';
import { getHolidaysForState, type Holiday } from '../data/germanHolidays';

export function useHolidays(): Holiday[] {
  const { state } = useApp();
  const { year, settings } = state;

  return useMemo(() => {
    return getHolidaysForState(year, settings.federalState);
  }, [year, settings.federalState]);
}

export function useIsHoliday(dateString: string): Holiday | undefined {
  const holidays = useHolidays();
  return holidays.find((h) => h.date === dateString);
}
